import { IContainer, ILazyBinder, injectContainer } from '../../interface/container';

export type ZipBinaryStorageType = Blob | ArrayBuffer;

export interface IZip {
    unzipFile: <T extends ZipBinaryStorageType>(blobData: T, fileName: string) => Promise<T>;
    unzipAll: <T extends ZipBinaryStorageType>(blobData: T) => Promise<Record<string, T>>;
    listings: (blobData: ZipBinaryStorageType) => Promise<Array<string>>;
}

const TYPES = {
    IZip: Symbol.for('IZip'),
};

export function injectZip(container: IContainer = injectContainer()): Promise<IZip> {
    return container.get<ILazyBinder<IZip>>(TYPES.IZip)();
}

export function bindZip(val: ILazyBinder<IZip>, container: IContainer = injectContainer()) {
    return container.bind<ILazyBinder<IZip>>(TYPES.IZip, val);
}

export function unbindZip(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IZip);
}
